const { default: axios } = require("axios");

var system = {
    // Всплывающие информационные окона...
	alert: {
		timeout:0,
		array:[],
		elem: document.getElementById('alertElem'),
		// Запуск
		run: function(text){
		  // Если уже запущен, то ложим сообщение в архив и возвращаем.
		  if(system.alert.timeout){
			// В конкретном случае накопления не нужны.
			//   system.alert.array.push(text);
			  return;
		  }
		  
		  // Открываем окно
		  system.alert.elem.innerText = text;
		  system.alert.elem.classList.add('alerton');
		  
		  // Закрываем его через 1500.
		  system.alert.timeout = setTimeout(function(){
			  system.alert.elem.classList.remove('alerton');
			  system.alert.timeout = 0;
			  
			  // Если в очереди что-то есть, то перезапускаем окно.
			  if(system.alert.array.length){
				  setTimeout(function(){
					  system.alert.run(system.alert.array.shift());
				  },100);
				  return;
			  }
			  
			  // Если очередь пуста, то закрываем до конца.
			  setTimeout(function(){
				  system.alert.elem.innerText = '';
			  },500);
			  
		  },1500);
		}
	},

	resizeFinishModal: function(){
		if(!document.querySelector('.modal-body-finish')){
			return;
		}

		// Без таймаута получает высоту на 23 пикселя меньше. Пока не понял почему.
		setTimeout(function(){
			let fullHeight = document.documentElement.clientHeight;
			let bodyHeight = document.querySelector('.modal-body-finish > div:first-child').clientHeight;

			if(bodyHeight < fullHeight){
				document.querySelector('.modal-body-finish').classList.remove('scrolled');

				return;
			}

			document.querySelector('.modal-body-finish').classList.add('scrolled');
		},40);
	},

	modal: {
		elem: document.getElementById('modalContainer'),
		body: document.getElementById('modalBodyContainer'),
		isOpen: false,
		checkOverflow: function(){
			if(!system.modal.isOpen){
				return;
			}

			// Без таймаута получает высоту на 23 пикселя меньше. Пока не понял почему.
			setTimeout(function(){
				let fullHeight = document.documentElement.clientHeight;
				let bodyHeight = document.querySelector('#modalBodyContainer div').clientHeight;

				if(bodyHeight < fullHeight){
					document.getElementById('modalBody').classList.remove('scrolled');
	
					return;
				}
	
				document.getElementById('modalBody').classList.add('scrolled');
			},40);
		},
		open: function(html){
			if(html){
				system.modal.body.innerHTML = html;
			}

			system.modal.elem.classList.remove('d-none');
			document.body.style.overflowY = 'hidden';
			
			if(system['boot_level_' + window.params.level]) {
				system['boot_level_' + window.params.level]();
			}
			
			system.modal.isOpen = true;

			system.modal.checkOverflow();
		},
		close: function(){
			document.body.style.overflowY = 'auto';
			system.modal.elem.classList.add('d-none');
			
			if(system.close){
				system.close = false;
				system.closeLevel();
			}

			if(system['close_level_' + window.params.level]) {
				system['close_level_' + window.params.level]();
			}

			system.modal.isOpen = false;
		}
	},

	scroll: function(id){
		let elem = document.getElementById(id);
		if(!elem) return;

		elem.scrollIntoView({block: 'start'});
	},

	levels: [
		'','level-1','level-2','level-3','level-4','level-5','finish'
	],

	closeLevel: function(){
		elem = document.querySelector('#main .level-note');
		if(!elem) return false;

		elem.innerText = 'Пройдено';
		elem.classList.add('level-ready');
		elem.classList.remove('level-note');
		elem.removeAttribute('data-type');

		params.level++;

		system.scroll(system.levels[window.params.level]);
	},

	close: false,

	// Здесь хранится то, что будем отправлять на сервер.
	postData: false,

	persAjax: function(result){
		system.modal.open(result.data.modal);
	
		if(result.data.landing){
			let el = document.createElement('div');
			document.getElementById('main').appendChild(el);
	
			el.outerHTML = result.data.landing;
	
			system.close = true;
		}
	},

	persError: function(result){},

	/**
	 * Обработка движения мыши или касания тачпада. НАЧАЛО.
	 */
	shiftX: null,
	onThumbDown: function(event){
		event.preventDefault(); // prevent selection start (browser action)

		document.querySelector('#game .lid_catcher').style.transitionDuration = '0s';

		if(!system.gameStarted){
			system.startGame();
		}

		if(system.modal.isOpen && system.gamePaused){
			system.resumeGame();
		}

		let thumb = document.querySelector('.lid_catcher');
		
		system.shiftX = event.clientX - thumb.getBoundingClientRect().left;
	
		thumb.setPointerCapture(event.pointerId);
	
		thumb.onpointermove = system.onThumbMove;
	
		thumb.onpointerup = event => {
			// dragging finished, no need to track pointer any more
			// ...any other "drag end" logic here...
			thumb.onpointermove = null;
			thumb.onpointerup = null;
		}
	},
	onThumbMove: function(event){
		let slider = document.getElementById('game');
		let thumb = slider.querySelector('.lid_catcher');

		let newLeft = event.clientX - system.shiftX - slider.getBoundingClientRect().left;

		// if the pointer is out of slider => adjust left to be within the boundaries
		if (newLeft < 0) {
		newLeft = 0;
		}
		let rightEdge = slider.offsetWidth - thumb.offsetWidth;

		if (newLeft > rightEdge) {
			newLeft = rightEdge;
		}
		thumb.style.left = newLeft + 'px';
	},
	/**
	 * Обработка движения мыши или касания тачпада. КОНЕЦ.
	 */

	/**
	 * Обработка нажатия стрелок вправо и влево. НАЧАЛО.
	 */
	arrowDown: function(event){
		if(!document.getElementById('game')){
			return true;
		}

		if(!system.gameStarted){
			system.startGame();
		}

		if(system.modal.isOpen && system.gamePaused){
			system.resumeGame();
		}

		clearInterval(system.upInterval);

		if(event.repeat){
			return false;
		}

		let thumb = document.querySelector('#game .lid_catcher');
		thumb.style.transitionDuration = '0.1s';

		if(!system.modificator){
			system.arrowInterval = setInterval(system.intervalBody,50);
		}
		
		system.modificator = event.key == 'ArrowLeft' ? -1 : 1;

		document.addEventListener('keyup',system.arrowUp);
	},
	upInterval: null,
	arrowUp: function(event){
		clearInterval(system.arrowInterval);

		system.modificator = null;

		document.removeEventListener('keyup',system.arrowUp);
	},
	arrowInterval: null,
	deletedLids: 0,
	modificator: null,
	intervalBody: function(){
		let thumb = document.querySelector('#game .lid_catcher');

		let current = Number(thumb.style.left.slice(0,-2));
		let newPosition = current + (system.modificator * 35);

		if(newPosition < 0){
			newPosition = 0;
		}	
		let rightEdge = document.getElementById('game').offsetWidth - thumb.offsetWidth;

		if (newPosition > rightEdge) {
			newPosition = rightEdge;
		}

		thumb.style.left = newPosition + 'px';
	},
	/**
	 * Обработка нажатия стрелок вправо и влево. КОНЕЦ.
	 */

	// Запускаем игру на уровне 5.
	boot_level_5: function(){
		if(system.gamePaused){
			return false;
		}

		let slider = document.getElementById('game');
		if(!slider){
			return false;
		}

		let thumb = slider.querySelector('.lid_catcher');
	  
		thumb.onpointerdown = system.onThumbDown;
	  
		thumb.ondragstart = () => false;

		let max = document.getElementById('game').offsetWidth - 50;

		system.arrayOfStoppedItems = Array.from(document.querySelectorAll('.one_lid'));
		system.arrayOfStoppedItems.forEach(elem => {
			elem.style.left = Math.floor(Math.random() * max) + 'px';
		});
	},
	// Закрыли окно игры когда игра уже, возможно, стартовала.
	close_level_5: function(){
		if(!document.getElementById('game')){
			return false;
		}

		if(!system.gameFinished){
			system.gamePaused = true;
			document.getElementById('gameResumeButton').classList.remove('d-none');
		}
	},

	/**
	 * Сама игра. НАЧАЛО.
	 */
	// Пока не запущенные элементы.
	arrayOfStoppedItems: [],
	// Обрабатывает падающие элементы.
	gameTick: function(){
		if(system.gamePaused) {
			return false;
		}

		// Выбираем активные элементы, которые будут падать.
		let elems = document.querySelectorAll('.one_lid[speed]');

		for(let i = 0; i < elems.length; i++){
			let one = elems[i];

			// Текущее положение лида.
			let current = Number(one.style.top.slice(0,-2));

			// Если лид выпал из поля, то удаляем его совсем.
			if(current >= system.gameHeight){
				one.remove();
				system.deletedLids++;
				console.log(document.querySelectorAll('.one_lid'));
				// Если упал последний, то останавливаем игру.
				if(document.querySelectorAll('.one_lid').length === 0){
					system.stopGame();
				}

				continue;
			}

			// Считаем новую позицию на текущий тик.
			current += Number(one.getAttribute('speed'));

			// Если лид упал близко к краю, то считаем поймал ли его ловец.
			if(current >= system.gameHeight){
				system.countOneScore(one);
			}

			// Спускаем элемент ниже.
			one.style.top = current + 'px';

		};
	},
	// Необходимая ширина заезда лида на ловца, чтобы считаться пойманным в пикселях.
	touchWidth: 1,
	// Обновляем счет для конкретного лида.
	countOneScore: function(one){
		let thumb = document.querySelector('#game .lid_catcher');
		// Ловец.
		let thumbLeft = thumb.style.left.slice(0,-2);
		let thumbWidth = thumb.offsetWidth;

		// Лид.
		let ballLeft = one.style.left.slice(0,-2);
		let ballWidth = one.offsetWidth;

		// Получаем в переменную пойман ли лид.
		let catched = thumbLeft < ballLeft ?
			// Если ловец левее лида, то нужно, чтобы
			// дистанция между ними была меньше длинны ловца.
			Math.abs(ballLeft - thumbLeft + system.touchWidth) < thumbWidth :
			// Если правее, то дистанция должна быть меньше ширины лида.
			Math.abs(thumbLeft - ballLeft + system.touchWidth) < ballWidth;

		let score;
		// Какой из циферблатов увеличить.
		if(catched) {
			score = document.getElementById('gameScoreYes');
		}
		if(score){
			// Обновляем счет.
			let currentScore = Number(score.innerText);
			score.innerText = currentScore + 1;
		}
	
	},
	// Кидает элементы.
	gameAddNewItem: function(){
		// Запускаем элемент.
		let elem = system.arrayOfStoppedItems.pop();
		
		// Скорость. От 12 до 30 пикселей за тик.
		elem.setAttribute('speed',Math.floor(Math.random() * 18) + 12);
		// Смещение относительно прямого падения.
		// elem.setAttribute('direction',Math.floor(Math.random() * 20) - 10);

		// Если к этому моменту еще остались не запущенные элементы, то перезапускаем таймер.
		if(system.arrayOfStoppedItems.length && ! system.gamePaused){
			setTimeout(system.gameAddNewItem,Math.floor(Math.random() * 700) + 500);
		}
	},
	// Стартанула ли игра.
	gameStarted: false,
	// Идентификатор интевала игры.
	gameInterval: null,
	gameHeight: null,
	// Просто стартует игру при первом контакте с ловцом.
	startGame: function(){
		// Старт.
		system.gameStarted = true;
		// Каждые 50мл.сек обновление падающих лидов.
		system.gameInterval = setInterval(system.gameTick,50);
		// Каждую секунду запускаем новый лид.
		setTimeout(system.gameAddNewItem,1000);
		// Просто запоминаем высоту игрового поля.
		system.gameHeight = document.getElementById('game').offsetHeight;
	},
	gameFinished: false,
	stopGame: function(){
		system.gameFinished = true;
		clearInterval(system.gameInterval);
		document.getElementById('afterGameText').classList.remove('d-none');
	},
	gamePaused: false,
	resumeGame(){
		document.getElementById('gameResumeButton').classList.add('d-none');
		system.gamePaused = false;
		setTimeout(system.gameAddNewItem,Math.floor(Math.random() * 700) + 500);
	}
	/**
	 * Сама игра. КОНЕЦ.
	 */
};
window.system = system;

window.onresize = function(){
	system.modal.checkOverflow();
	system.resizeFinishModal();
};

window.onload = function(){
	// Будем ловить события нажатия.
	document.addEventListener('click',function(event){
	  // Ловятся только те, что имеют структуру
	  //  <div data-role="menu-navigator">
	  //      <div data-type="eventName">ELEMENT</div>
	  //  </div>
	  let navigator = event.target.closest('[data-role="menu-navigator"]');
	  let target = event.target.closest('[data-type]');
	  
	  if(!navigator || !target || !navigator.contains(target)) return;
	  
	  let eventType = 'eventType_'+target.dataset['type'];
	  if(!system[eventType]) return;

	  event.preventDefault();

	  // Если у навигатора есть beforeCallback, то запускаем.
	  if(navigator.dataset['nav']){
		let navMethod = 'navigator_' + navigator.dataset['nav'];
		if(system[navMethod] && !system[navMethod](navigator,target)) return;
	  }

	  // Запуск самого события.
	  system[eventType](target,navigator);
	});
	
	// Закрываем модальное окно при клике по туману.
	document.onkeydown = function(event){
		// Если модальное окно закрыто, то дальше.
		if(system.modal.elem.classList.contains('d-none')) return true;

		// Эскейп закрывает в любом случае.
		if(event.key == 'Escape'){
			system.modal.close();
			return false;
		}

		if(event.key == 'ArrowLeft' || event.key == 'ArrowRight'){
			return system.arrowDown(event);
		}

		return true;
	};

	params.level = Number(params.level);

	// Прокрутка экрана к уровню при первой загрузке.
	system.scroll(system.levels[window.params.level]);
};

// Текущий выделенный элемент пазла.
system.currentSlice = false;
// Доступно ли выделение прямо сейчас.
system.sliceAvailable = true;
// Реагируем на события пазла.
system.eventType_slice = function(target){
  if(!system.sliceAvailable){
	return;
  }

  // Сначала проверяем не нажата ли иконка второй раз.
  if(target.querySelector('input').id == system.currentSlice){
	target.querySelector('input').checked = false;
	system.currentSlice = 0;
	return;
  }

  // Если это первое нажатие.
  if(!system.currentSlice){
	system.currentSlice = target.querySelector('input').id;
	target.querySelector('input').checked = true;
	return;
  }

  system.sliceAvailable = false;

  // Сюда попадаем только если нужно поменять 2 фрагмента.
  let from = document.getElementById(system.currentSlice);
  from.checked = false;
  from = from.parentElement;
  let to = target.querySelector('input').parentElement;

  // Теперь нужно поменять их местами.
  let temp = document.createElement('div');
  temp.innerHTML = from.outerHTML;
  from.outerHTML = to.outerHTML;
  to.outerHTML = temp.innerHTML;

  system.sliceAvailable = true;
  system.currentSlice = false;
}

// Просто закрыть модальное окно.
system.eventType_modalClose = function(){
	system.modal.close();
};

// Отправить запрос на сервер и открыть модальное окно с пришедшим содержимым.
system.eventType_modalOpen = function(target){
	if(system.gamePaused || system.gameFinished){
		return system.modal.open();
	}

	axios.get('/',{headers: {'X-Requested-With': 'XMLHttpRequest'}}).then(system.persAjax,system.persError);
}

// Отправить результат задания на сервер и обновить модальное окно.
system.eventType_modalPost = function(target){
	axios.post('/',system.postData,{headers: {'X-Requested-With': 'XMLHttpRequest'}}).then(system.persAjax,system.persError);
}

// Базовый навигатор. Просто собирает значения всех inputs.
system.navigator_base = function(navigator){
	let form = navigator.querySelector('form');

	system.postData = form ? new FormData(form) : null;

	if(system.postData && !system.postData.get('answer')){
		// Здесь вывести сообщение о том, что нужно выбрать ответ...
		system.alert.run('Выберите ответ!');
		
		return false;
	}

	return true;
}

// Специальный навигатор для пазла.
system.navigator_slice = function(navigator){
	let inputs = navigator.querySelectorAll('input[type="radio"]');

	let result = [];

	inputs.forEach(input => {
		result.push(input.id.slice(1));
	});

	let data = new FormData;
	data.append('answer',result.join('-'));

	system.postData = data;

	return true;
}

// Специальный навигатор для ловца лидов.
system.navigator_game = function(navigator){
	if(!system.gameFinished){
		return system.alert.run('Сначала завершите игру!');
	}

	let score = Number(document.getElementById('gameScoreYes').innerText);

	let data = new FormData;
	data.append('answer',score);

	system.postData = data;

	return true;
}

document.addEventListener('DOMContentLoaded', function(){
    document.addEventListener('click', function(e){
        let btn = e.target.closest('.copy-link')

        if(!btn) return

        let linkValue = btn.dataset.shared;
		console.log(linkValue);
        let textArea = document.createElement("textarea");
        textArea.value = linkValue;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
		console.log(textArea);

        document.execCommand('copy');
        document.body.removeChild(textArea);

        btn.classList.add('copy-link-done')

        setTimeout(function(){
            btn.classList.remove('copy-link-done')
        }, 2000)
    })
})
